import * as t from 'io-ts';

export const AirportDetailsDynamicType = t.interface({
    location: t.string,
    airportId: t.union([t.string, t.null]),
    reportTo: t.union([t.string, t.null]),
    address: t.union([t.string, t.null]),
    directions: t.union([t.string, t.null]),
    reportTime: t.union([t.string, t.null]),
    telephoneNumber: t.union([t.string, t.null])
});

export type AirportDetails = t.TypeOf<typeof AirportDetailsDynamicType>;

export const AirportDynamicType = t.interface({
    id: t.string,
    name: t.string,
    town: t.union([t.string, t.null]),
    iataCode: t.union([t.string, t.null]),
    icaoCode: t.union([t.string, t.null])
});

export type Airport = t.TypeOf<typeof AirportDynamicType>;
